import { SidebarExtensionSDK } from '@contentful/app-sdk';

export const updateEntry = async (fields: { [key: string]: { [key: string]: string | Document } }, locale: string, sdk: SidebarExtensionSDK) => {
  Object.entries(fields).forEach(async ([fieldId, fieldValue]) => {
    if (sdk.entry.fields[fieldId]) {
      await sdk.entry.fields[fieldId].getForLocale(locale).setValue(fieldValue[locale]);
    }
  });
};
